module.exports = __webpack_public_path__ + "static/parallax-profesional-trabajando-f66dc0c59480ea52d46e76c389f8b67a.jpg";